module.exports = __webpack_public_path__ + "img/freddies-van.9ece0e18.svg";